import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import ModalHandlerComponent from './ModalHandlerComponent';

import { onModalClose } from './actions';

const ModalHandlerContainer = (props) => {
  const {
    modalClose,
    modal: { modalProps = {} },
  } = props;
  const { id, customModalClose = null } = modalProps;
  const [isModalMinimized, setIsModalMinimized] = useState(false);

  useEffect(() => {
    setIsModalMinimized(false);
  }, [id]);

  const onModalMinimized = () => {
    const body = document.querySelector('body');
    if (body) {
      body.style.overflow = !isModalMinimized ? 'auto' : 'hidden';
    }

    setIsModalMinimized(!isModalMinimized);
  };

  const onModalClose = () => {
    setIsModalMinimized(false);
    customModalClose && customModalClose();
    modalClose();
  };

  return (
    <ModalHandlerComponent
      {...props}
      isModalMinimized={isModalMinimized}
      setIsModalMinimized={onModalMinimized}
      onModalClose={onModalClose}
    />
  );
};

const mapStateToProps = ({ modal }) => ({
  modal,
});

const mapDispatchToProps = (dispatch) => ({
  modalClose: () => onModalClose(dispatch),
});

ModalHandlerContainer.defaultProps = {
  modal: {},
};

ModalHandlerContainer.propTypes = {
  modalClose: PropTypes.func.isRequired,
  modal: PropTypes.instanceOf(Object),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalHandlerContainer);
